const platformAdminTutorial = {
  module: 'platform_admin',
  moduleName: 'Platform Admin',
  steps: [
    { target: '.platform-toolbar', position: 'bottom', title: 'Management', description: 'Search, create, and manage organizations, tenants, and users.' },
    { target: '.admin-tabs', position: 'bottom', title: 'Tabs', description: 'Switch between organizations, sites, users, licenses, and system tools.' },
  ],
};
export default platformAdminTutorial;
